import React, { useContext, useEffect, useState } from 'react';
import { capitalizeNames, formatterPhone as utilsFormatterPhone } from '../../../../../../@common/utils/formatters/formatter';
import { useCreateResponseTask } from '../../../../../../services/task/mutations';
import {
  Task,
  TaskResponse,
  TaskState
} from '../../../../../../gql/graphql';
import { TaskContext } from '../Insurance';
import { useGetTaskResponsesByTask } from '../../../../../../services/task/querys';
import { Collapse, Form } from 'antd';
import InputBorderNone from 'components/Atoms/Inputs/InputBorderNone/InputBorderNone';
import ButtonSubmit from 'components/Atoms/Buttons/ButtonSubmit/ButtonSubmit';
import StateTag from 'components/Atoms/Tags/StateTag/StateTag';

interface IForm {
  titleCompany: string;
  name: string;
  phone: string;
  email: string;
}

interface Props {
  onModalFinish: Function;
  disabled: boolean;
}

const Contact = ({ onModalFinish, disabled }: Props) => {
  const [form] = Form.useForm();
  const task: Task | any = useContext(TaskContext);

  const { data: taskResponses, reexecute: getTaskResponses } = useGetTaskResponsesByTask({
    variables: { findResponsesByTask: { taskId: task._id } }
  });
  const { fetching, data: isCreateResponse, execute: createResponseTask } = useCreateResponseTask();

  const [emailError, setEmailError] = useState<boolean>(false);
  const [responseInfo, setResponseInfo] = useState<TaskResponse | any>();

  useEffect(() => {
    if (responseInfo && responseInfo.state !== TaskState.RequestError)
      form.setFieldsValue(responseInfo.metadata);
  }, [responseInfo])

  useEffect(() => {
    const _response = taskResponses?.find((item) => item.step === 2 && item.key === 'insurance-information');
    setResponseInfo(_response);
  }, [taskResponses]);

  const formatterPhone = (e: any) => {
    form.setFieldValue('phone', utilsFormatterPhone(e.target.value));
  };

  const onFinish = async (values: IForm) => {
    values.name = capitalizeNames(values.name);

    await createResponseTask({
      _id: responseInfo?._id,
      task: task._id,
      key: `insurance-information`,
      label: `We’ll reach out and get insurance documents`,
      step: 2,
      metadata: values,
      state: TaskState.Review
    });

    getTaskResponses({ requestPolicy: 'network-only' });
    onModalFinish();
  }

  return (
    <div
      id={responseInfo?._id}
      style={{ position: 'relative' }}
      className={`mt-40 title-company-step-1 title-company-step-1-${responseInfo?.state}`}
    >
      {responseInfo?.state && responseInfo?.state !== TaskState.Review && <StateTag state={responseInfo?.state} />}
      {responseInfo?.state && responseInfo?.state === TaskState.Review && <StateTag state={responseInfo?.state} isLabelLocked />}

      <Form
        name="edit"
        autoComplete="off"
        requiredMark="optional"
        colon={false}
        form={form}
        onFinish={onFinish}
        disabled={disabled || (responseInfo && responseInfo?.state !== TaskState.RequestError)}
      >
        <Form.Item
          label=""
          name="insuranceCompany"
          className="titleCompany"
          rules={[{ required: true, message: 'This field is required' }]}
        >
          <InputBorderNone
            placeholder="Insurance company name"
            className="bold"
          />
        </Form.Item>
        <Form.Item
          label="Contact name"
          name="name"
          className="name"
          rules={[{ required: true, message: 'This field is required' }]}
        >
          <InputBorderNone
            placeholder="Nicolas Ortiz"
            height={20}
            className="bold-lith"
          />
        </Form.Item>

        <Form.Item
          label="Phone number"
          name="phone"
          className="phone"
          validateTrigger={['onChange', 'onBlur']}
          rules={[
            { required: true, message: 'Phone number is required' },
            { min: 10, message: 'Enter a valid 10-digit phone number' }
          ]}
        >
          <InputBorderNone
            placeholder="203-423-3534"
            height={20}
            className="bold-lith"
            onChange={formatterPhone}
            maxLength={10}
          />
        </Form.Item>

        <Form.Item
          label="Email address"
          name="email"
          className="email"
          rules={[{ required: true, type: 'email', message: 'Invalid email address' }]}
        >
          <InputBorderNone
            type="email"
            placeholder="lend@constlending.com"
            height={20}
            color={emailError ? 'error' : 'bold-lith'}
            onBlur={(e: any) => setEmailError(e.target.value && form.getFieldError('email').length > 0)}
          />
        </Form.Item>

        {responseInfo?.state !== TaskState.Approved &&
          <Form.Item className="submit" shouldUpdate>
            {() => (
              <ButtonSubmit
                disabled={
                  responseInfo?.state === TaskState.Review ||
                  !form.getFieldsError().every((fieldErr) => fieldErr.errors.length === 0) ||
                  !form.isFieldsTouched() ||
                  !Object.values(form.getFieldsValue()).every(value => value)
                }
                loading={fetching}
                modalConfirm={{ show: true }}
                onClick={form.submit}
              >
                Submit for review
              </ButtonSubmit>
            )}
          </Form.Item>
        }
      </Form>
    </div>
  );
};
export default Contact;
